/* eslint-disable @typescript-eslint/no-explicit-any */
import { ModuleBase } from './ModuleBase'
import { hall } from '@/hall'
import { base } from '@/base/base'
import * as proto from '@/proto/proto.js'
import { MsgIDs } from '@/defines/MsgIDs'
import { PopupViews } from '@/defines/EnumDefine'
import { wsClient } from '@/net/WebSocketClient'

export class SignModule extends ModuleBase {
  private signInfo: any = null
  public signInfoNew: any = null
  public signResult: any = null //签到结果数据

  init(): void {}

  onClear(): void {}

  onLoad(): void {}

  onDestroy(): void {}

  setSignInfo(info: any) {
    this.signInfo = info
  }

  inits2c(): void {
    ;(hall.s2c as any)['onClientSignActivityAck'] = (msg: proto.ClientSignActivityAck) => {
      if (msg == null || (msg as any).ret != 0 || (msg as any).UserID != hall.userModule.userId) {
        return
      }

      ;(msg as any).Sign7Status = (msg as any).Sign7Status || 0
      this.setSignInfo(msg)
      hall.eventDispatcher.emit(hall.EventDefine.SignInfoChange)
      hall.eventDispatcher.emit(hall.EventDefine.ChangeBindActivityRed) //刷新签到红点
    }

    //累计
    ;(hall.s2c as any)['onClientSignActivityAggAck'] = (msg: proto.ClientSignActivityAggAck) => {
      if (msg == null || (msg as any).ret != 0 || (msg as any).UserID != hall.userModule.userId) {
        return
      }

      hall.userModule.setProperty(
        (msg as any).UserGold,
        (msg as any).UserDeposit,
        (msg as any).UserWithdraw,
        (msg as any).UserBonus,
        '',
      )
      hall.eventDispatcher.emit(hall.EventDefine.SignRewardAgg)
    }

    //
    ;(hall.s2c as any)['onClientSignActivityInAck'] = (msg: proto.ClientSignActivityInAck) => {
      if (msg == null || (msg as any).ret != 0 || (msg as any).UserID != hall.userModule.userId) {
        return
      }

      hall.userModule.setProperty(
        (msg as any).UserGold,
        (msg as any).UserDeposit,
        (msg as any).UserWithdraw,
        (msg as any).UserBonus,
        '',
      )

      if ((msg as any).SignType == 2) {
        this.signInfoNew.Sign7Status = 2
        this.sendSignConfig() //拉取一遍数据
      } else if ((msg as any).SignType == 3) {
        this.signInfoNew.Sign7Status = 3
      }
      this.signResult = msg
      hall.eventDispatcher.emit(hall.EventDefine.SignReward)
    }
  }

  onPreloadData(): void {
    this.sendSignConfig()
  }

  //请求签到活动
  sendSignConfig(): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
    }

    wsClient.send(MsgIDs.ClientSignActivityReq, msg)
  }

  //点击累计签到奖励
  sendAGGSignClick(nPropward: any): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
      Propward: nPropward,
    }
    wsClient.send(MsgIDs.ClientSignActivityAggReq, msg)
  }

  //点击签到
  sendSignClick(signType: any): void {
    const msg = {
      UserID: hall.userModule.userId,
      ChannelID: base.channelId,
      SignType: Number(signType),
    }
    wsClient.send(MsgIDs.ClientSignActivityInReq, msg)
  }

  //处理签到信息
  getSignInfos() {
    if (
      this.signInfo == null ||
      this.signInfo.Sign7Cof == null ||
      this.signInfo.Sign30Cof == null ||
      this.signInfo.Sign30Status == null
    ) {
      return null
    }

    const changeSignInfo = { ...this.signInfo }
    const Sign7Cof = JSON.parse(this.signInfo.Sign7Cof) //reward_type:1金币；2免费转
    const Sign30Cof = JSON.parse(this.signInfo.Sign30Cof) //
    const Sign30Status = JSON.parse(this.signInfo.Sign30Status)

    changeSignInfo.Sign7Cof = Sign7Cof
    changeSignInfo.Sign30Cof = Sign30Cof
    changeSignInfo.Sign30Status = Sign30Status

    this.signInfoNew = changeSignInfo
    return changeSignInfo
  }

  //判断是否有签到
  isCanSign() {
    return false
  }

  // 是否需要弹窗
  popupView() {
    if (wsClient.isNetConnected()) {
      hall.popupViewModule.addPopupView(PopupViews.SignPanel)
    }
  }

  isGetedPopupData() {
    return this.signInfo != null
  }
}
